module.exports = __webpack_public_path__ + "static/media/PROCEDIMIENTO PARA TOMA DE DECISIONES.92d92a60.pdf";